import React from "react";
import { Workflow, Mic, Target, Trophy, MessageSquare, Brain, Smile } from "lucide-react";

function StatCard({ icon: Icon, label, value, testid }) {
  return (
    <div className="glass-panel rounded-xl p-4" data-testid={testid}>
      <Icon className="w-4 h-4 text-indigo-400 mb-2" />
      <p className="text-lg font-heading font-bold text-white">{value}</p>
      <p className="text-[11px] text-slate-400">{label}</p>
    </div>
  );
}

export default function PerformanceStatsSection({ simulatorPerformance, interviewAnalytics }) {
  return (
    <div className="space-y-6" data-testid="portfolio-performance-stats">
      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3 flex items-center gap-1.5"><Workflow className="w-3.5 h-3.5" /> Simulator Performance</p>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
          <StatCard icon={Workflow} label="Total Simulations" value={simulatorPerformance.total_simulations} testid="sim-stat-total" />
          <StatCard icon={Target} label="Success Rate" value={`${simulatorPerformance.success_rate}%`} testid="sim-stat-success-rate" />
          <StatCard icon={Trophy} label="Best Score" value={`${simulatorPerformance.best_score}%`} testid="sim-stat-best-score" />
          <StatCard icon={Brain} label="Favorite Scenario" value={simulatorPerformance.favorite_business_scenario || "N/A"} testid="sim-stat-favorite" />
        </div>
      </div>

      <div>
        <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-3 flex items-center gap-1.5"><Mic className="w-3.5 h-3.5" /> Mock Interview Analytics</p>
        {interviewAnalytics.total_interviews === 0 ? (
          <p className="text-sm text-slate-400" data-testid="interview-analytics-empty">No mock interviews completed yet.</p>
        ) : (
          <>
            <div className="grid grid-cols-2 sm:grid-cols-5 gap-3">
              <StatCard icon={Mic} label="Total Interviews" value={interviewAnalytics.total_interviews} testid="interview-stat-total" />
              <StatCard icon={Brain} label="Technical" value={`${interviewAnalytics.avg_technical_score}%`} testid="interview-stat-technical" />
              <StatCard icon={MessageSquare} label="Communication" value={`${interviewAnalytics.avg_communication_score}%`} testid="interview-stat-communication" />
              <StatCard icon={Target} label="Problem Solving" value={`${interviewAnalytics.avg_problem_solving_score}%`} testid="interview-stat-problem-solving" />
              <StatCard icon={Smile} label="Confidence" value={`${interviewAnalytics.avg_confidence_score}%`} testid="interview-stat-confidence" />
            </div>
            {interviewAnalytics.latest_feedback && (
              <p className="text-xs text-slate-400 italic mt-3" data-testid="interview-latest-feedback">"{interviewAnalytics.latest_feedback}"</p>
            )}
          </>
        )}
      </div>
    </div>
  );
}
